module.exports = __webpack_public_path__ + "img/18.71323b2a.png";